export default __webpack_public_path__ + "static/media/Mobile-login-pana.273b7b66.svg";